var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Command from '../Command';
import Session from '../../services/Session';
import refresh from '../../requests/authentication/refresh';
/**
 *
 */
var RefreshCommand = /** @class */ (function (_super) {
    __extends(RefreshCommand, _super);
    function RefreshCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @return {Promise<any | never>}
     */
    RefreshCommand.prototype.execute = function () {
        var promise = refresh();
        promise.then(this.then).catch(this.catch);
        return promise;
    };
    RefreshCommand.prototype.then = function (response) {
        Session.setJWT(response);
    };
    RefreshCommand.prototype.catch = function (error) {
        Session.setJWT(null);
    };
    return RefreshCommand;
}(Command));
export default RefreshCommand;
